// DwsLazyLoad: tells .NET when its placeholder comes into view. Core: small, and on most pages.

import { publish } from "../shared/publish";

const dwsLazyLoadObservers: Record<string, IntersectionObserver> = {};

function dwsRegisterLazyLoadObserver(elementId: string, dotNetHelper: DotNetObject, prefetchThreshold?: number): void {
    if (!window.IntersectionObserver) {
        dotNetHelper.invokeMethodAsync('OnLazyLoadVisible');
        return;
    }
    const elem = document.getElementById(elementId);
    if (!elem) return;
    dwsUnregisterLazyLoadObserver(elementId);
    const options = { root: null, rootMargin: prefetchThreshold ? `${prefetchThreshold}px` : '0px', threshold: 0.01 };
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                dotNetHelper.invokeMethodAsync('OnLazyLoadVisible');
                obs.unobserve(entry.target);
                dwsUnregisterLazyLoadObserver(elementId);
            }
        });
    }, options);
    observer.observe(elem);
    dwsLazyLoadObservers[elementId] = observer;
}

function dwsUnregisterLazyLoadObserver(elementId: string): void {
    const observer = dwsLazyLoadObservers[elementId];
    if (observer) { observer.disconnect(); delete dwsLazyLoadObservers[elementId]; }
}

publish("dwsRegisterLazyLoadObserver", dwsRegisterLazyLoadObserver);
publish("dwsUnregisterLazyLoadObserver", dwsUnregisterLazyLoadObserver);
